import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config.json';
import { createAuth } from '../Helpers';

export const reducerName = 'documentStore';

export interface DocumentState {
    documents: any[];
    activeDocument: any | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: DocumentState = {
    documents: [],
    activeDocument: null,
    status: 'idle',
    error: null,
};

export const getAllDocuments = createAsyncThunk(
    'documentStore/getAll',
    async (_, { getState, rejectWithValue }) => {
        try {
            // @ts-ignore
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/documents`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            const err = error as any;
            console.error('ERROR FETCHING DOCUMENTS', err);
            return rejectWithValue(err.response?.data || 'An error occurred');
        }
    }
);

const documentSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setActive: (state, action: PayloadAction<any>) => {
            state.activeDocument = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDocuments.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllDocuments.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.documents = action.payload;
                if (state.activeDocument === null && action.payload.length > 0) {
                    state.activeDocument = action.payload[0];
                }
            })
            .addCase(getAllDocuments.rejected, (state, action) => {
                state.status = 'failed';
                state.error = (action.payload as string) || 'An error occurred';
            });
    },
});

export const { setActive } = documentSlice.actions;

export default documentSlice.reducer;
